import React from 'react';
import PropTypes from 'prop-types';
import StoryboardContent from 'storyboard/components/storyboard-content';
import StoryboardIntroCard from 'storyboard/components/storyboard-intro-card';
import StoryboardLogoBar from 'storyboard/components/storyboard-logo-bar';
import * as ModalType from 'storyboard/constants/modal-type';
import StoryboardChapterModalContainer from 'storyboard/containers/storyboard-chapter-modal-container';
import StoryboardLogoModalContainer from 'storyboard/containers/storyboard-logo-modal-container';
import StoryboardThemeButtonContainer from 'storyboard/containers/storyboard-theme-button-container';
import StoryboardThemeModalContainer from 'storyboard/containers/storyboard-theme-modal-container';
import './index.scss';

export default class StoryboardApp extends React.Component {
  static propTypes = {
    dashboards: PropTypes.array,
    data: PropTypes.object.isRequired,
    enums: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    report: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {
      chapterModal: {
        isOpen: false,
      },
      logoModal: {
        isOpen: false,
      },
      themeModal: {
        isOpen: false,
      },
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  getFlexDirection(position, enums) {
    const {LogoBarPositionEnum} = enums;
    return position === LogoBarPositionEnum.BOTTOM.id
      ? 'column-reverse'
      : 'column';
  }

  closeModal() {
    this.setState({
      chapterModal: {
        isOpen: false,
      },
      logoModal: {
        isOpen: false,
      },
      themeModal: {
        isOpen: false,
      },
    });
  }

  openModal(type, title, chapter) {
    const modal = {
      chapter,
      title,
      type,
    };
    this.setState({
      chapterModal: {
        ...modal,
        isOpen:
          type === ModalType.ADD_CHAPTER ||
          type === ModalType.DELETE_CHAPTER ||
          type === ModalType.EDIT_CHAPTER,
      },
      logoModal: {
        ...modal,
        isOpen: type === ModalType.ADD_LOGO || type === ModalType.DELETE_LOGO,
      },
      themeModal: {
        ...modal,
        isOpen: type === ModalType.EDIT_THEME,
      },
    });
  }

  render() {
    return (
      <div
        className={'StoryboardApp'}
        style={{
          flexDirection: this.getFlexDirection(
            this.props.data.configuration.theme.logoBarPosition,
            this.props.enums,
          ),
        }}>
        <StoryboardLogoBar data={this.props.data} openModal={this.openModal} />
        <StoryboardContent
          data={this.props.data}
          enums={this.props.enums}
          location={this.props.location}
          openModal={this.openModal}
          report={this.props.report}
        />

        {!this.props.data.chapters.length ? (
          <StoryboardIntroCard
            data={this.props.data}
            enums={this.props.enums}
            openModal={this.openModal}
          />
        ) : null}

        {this.props.data.isEditable ? (
          <StoryboardChapterModalContainer
            chapterToEdit={this.state.chapterModal.chapter}
            closeModal={this.closeModal}
            dashboards={this.props.dashboards}
            data={this.props.data}
            enums={this.props.enums}
            isOpen={this.state.chapterModal.isOpen}
            title={this.state.chapterModal.title}
            type={this.state.chapterModal.type}
          />
        ) : null}

        {this.props.data.isEditable ? (
          <StoryboardThemeButtonContainer openModal={this.openModal} />
        ) : null}

        {this.props.data.isEditable ? (
          <StoryboardThemeModalContainer
            closeModal={this.closeModal}
            data={this.props.data}
            enums={this.props.enums}
            isOpen={this.state.themeModal.isOpen}
          />
        ) : null}

        {this.props.data.isEditable ? (
          <StoryboardLogoModalContainer
            closeModal={this.closeModal}
            data={this.props.data}
            isOpen={this.state.logoModal.isOpen}
            title={this.state.logoModal.title}
            type={this.state.logoModal.type}
          />
        ) : null}
      </div>
    );
  }
}
